import React, { useState, useEffect, useRef, useContext } from 'react';
import DataTable from 'react-data-table-component';
import pdf from '../../assets/images/file-pdf-solid.svg';
import csv from '../../assets/images/file-csv-solid.svg';
import { useAuth } from '../../hooks/customers/AuthProvider';
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import Select from "react-select";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { LoaderContext } from "../utils/Contexts";
import { DateRangePicker, Stack } from 'rsuite';

const columns = [
  {
    name: 'Category',
    selector: row => row.category_name || '-',
    sortable: true,
    // cell: row => (
    //   <div style={{ width: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
    //     {row.category_name || '-'}
    //   </div>
    // ),
  },
  {
    name: 'Product Name',
    selector: row => row.product_name,
    sortable: true,
    // cell: row => (
    //   <div style={{ width: '300px' }}>
    //     {row.product_name}
    //   </div>
    // ),
  },
  {
    name: 'Unit',
    selector: row => row.product_unit,
    sortable: true,
  },
  {
    name: 'Unit Price ($)',
    selector: row => parseFloat(row.product_price?.$numberDecimal || 0).toFixed(2),
    sortable: true,
  },
  {
    name: 'Total Qty',
    selector: row => row.total_quantity,
    sortable: true,
  },
  {
    name: 'Total Spent',
    selector: row => `$${parseFloat(row.total_spent || 0).toFixed(2)}`,
    sortable: true,
  },
];

function Reportdatatable({ setCategoryChartData, setProductCountByCategory }) {

  const pickerRef = useRef(null);
  const popupRef = useRef(null);
  const [active, setActive] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // useEffect(() => {
  //   const handleClick = (event) => {
  //     if (pickerRef.current && pickerRef.current.contains(event.target)) {
  //       setActive(false);
  //     } else {
  //       setActive(true);
  //     }
  //   };

  //   const handleScroll = () => {
  //     setActive(true);
  //   };

  //   document.addEventListener('click', handleClick);
  //   window.addEventListener('scroll', handleScroll);

  //   return () => {
  //     document.removeEventListener('click', handleClick);
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  // useEffect(() => {
  //     const handleScroll = () => {
  //       document.body.classList.add('datepickdis');
  //     };

  //     const handleInputInteraction = (e) => {
  //       if (e.target.tagName === 'INPUT' && e.target.type === 'text') {
  //         document.body.classList.remove('datepickdis');
  //       }
  //     };

  //     window.addEventListener('scroll', handleScroll);
  //     document.addEventListener('focus', handleInputInteraction, true);
  //     document.addEventListener('input', handleInputInteraction, true);
  //     document.addEventListener('click', handleInputInteraction, true);

  //     return () => {
  //       window.removeEventListener('scroll', handleScroll);
  //       document.removeEventListener('focus', handleInputInteraction, true);
  //       document.removeEventListener('input', handleInputInteraction, true);
  //       document.removeEventListener('click', handleInputInteraction, true);
  //     };
  //   }, []);



  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({
    branch: '',
    date: '',
  });
  const auth = useAuth();
  const customerId = auth.customer.id;
  const [branches, setBranches] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [invoice, setInvoice] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [range, setRange] = useState(null);

  // useEffect(() => {
  //   const link = document.createElement('link');
  //   link.rel = 'stylesheet';
  //   link.href = 'https://cdn.jsdelivr.net/npm/rsuite@latest/dist/rsuite.min.css';
  //   document.head.appendChild(link);

  //   return () => {
  //     document.head.removeChild(link); // clean up
  //   };
  // }, []);


  const getBranches = async () => {
    const url = `${ENDPOINTS.GET_BRANCHES}/${customerId}`;
    const response = await API.postWithToken(url);
    if (response.statusText === 'OK') {
      const branchOptions = response?.data?.data.items.map(branch => ({
        value: branch.id,
        label: branch.company,
      }));
      const allOption = { value: '', label: 'All' };
      setBranches([allOption, ...branchOptions]);
      // setBranches(branchOptions)
    }
  }

  const getCategories = async () => {
    const url = `${ENDPOINTS.GET_CATEGORIES}?limit=100`;
    const response = await API.getWithToken(url);
    if (response.statusText === 'OK') {
      const categoryOptions = response?.data?.data.categories.map(category => ({
        value: category.id,
        label: category.name,
      }));
      const allOption = { value: '', label: 'All' };
      setCategories([allOption, ...categoryOptions]);
      // setCategories(categoryOptions);
    }
  }

  const getProductsBasedCategory = async (company, category) => {
    setLoader(true);
    let url = `${ENDPOINTS.GET_PRODUCT_BASED_CATEGORY}/?&id=${customerId}`;
    if (company && company != 'All') {
      url += `&company=${encodeURIComponent(company)}`;
    }
    if (category && category != 'All') {
      url += `&category=${category}`;
    }
    if (filters.date && filters.date.start && filters.date.end) {
      url += `&start_date=${filters.date.start}&end_date=${filters.date.end}`;
    }
    const response = await API.postWithToken(url);
    if (response.statusText === 'OK') {
      const items = response?.data?.data.items.data;
      const filtered = items.filter(row => {
        const cat = row.category_name?.trim();
        return cat && cat.length > 0;
      });

      setProducts(filtered);
      setHasLoaded(true);
      setLoader(false);
    }
  }
  useEffect(() => {
    getBranches();
    getCategories();
  }, []);

  useEffect(() => {
    getProductsBasedCategory(selectedBranch?.label, selectedCategory?.label);
  }, [selectedBranch, selectedCategory, filters.date]);


  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFilters(prev => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  const filteredData = products.filter((row) => {

    // const matchBranch =
    //   !selectedBranch || selectedBranch.value === '' ||
    //   (row.branch && row.branch.toLowerCase().includes(selectedBranch.label.toLowerCase()));
    const normalize = str => str?.toString().trim().toLowerCase();

      const matchBranch =
        !selectedBranch || selectedBranch.value === '' ||
        (normalize(row.branch) === normalize(selectedBranch.label));

    const matchCategory =
      !selectedCategory || selectedCategory.value === '' ||
      (row.category_name && row.category_name.toLowerCase().includes(selectedCategory.label.toLowerCase()));


    // const matchDate =
    //   filters.date === '' ||
    //   (row.delivery_date && row.delivery_date.startsWith(filters.date));
    // const [start, end] = Array.isArray(range) ? range : [null, null];

    // const matchDate = !start || !end
    //   ? true
    //   : (() => {
    //     const rowDate = new Date(row.delivery_date);
    //     rowDate.setHours(0, 0, 0, 0);
    //     return rowDate >= start && rowDate <= end;
    //   })();
    const start = fromDate;
    const end = toDate;

    const matchDate = !start || !end
      ? true
      : (() => {
        const rowDate = new Date(row.delivery_date);
        rowDate.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        return rowDate >= start && rowDate <= end;
      })();


    return matchDate && matchCategory && matchBranch;
  });

  const handleBranchChange = (selected) => {
    setSelectedBranch(selected);
  };

  useEffect(() => {
    if (branches.length > 0 && !selectedBranch) {
      setSelectedBranch(branches[0]);
    }
    if (categories.length > 0 && !selectedCategory) {
      setSelectedCategory(categories[0]);
    }
  }, [branches, categories]);

  const handleCategoryChange = (selected) => {
    setSelectedCategory(selected);
  };

  const handleExportCSV = () => {
    const headers = columns.map(col => col.name);
    const rows = filteredData.map(row => {
      return columns.map(col => {
        const cell = typeof col.selector === 'function' ? col.selector(row) : row[col.selector];
        return `"${(cell && typeof cell === 'object' && 'display' in cell) ? cell.display : cell}"`;
      }).join(',');
    });

    const csvContent = [headers.join(','), ...rows].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'product_analysis_report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const handleExportPDF = () => {
    const doc = new jsPDF();

    const headers = [columns.map(col => col.name)];
    const data = filteredData.map(row =>
      columns.map(col => {
        const value = typeof col.selector === 'function' ? col.selector(row) : row[col.selector];
        return (value && typeof value === 'object' && 'display' in value) ? value.display : value;
      })
    );

    doc.autoTable({
      head: headers,
      body: data,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [52, 73, 94] },
    });

    doc.save('product_analysis_report.pdf');
  };

  useEffect(() => {
    if (filters.date) {
      setSelectedDate(new Date(filters.date));
    }
  }, [filters.date]);

  const chartData = Object.values(
    filteredData
      .filter(row => {
        const cat = row.category_name?.trim();
        return cat && cat !== 'Unknown';
      })
      .reduce((acc, row) => {
        const category = row.category_name?.trim();
        const spent = parseFloat(row.total_spent?.$numberDecimal || row.total_spent || 0);
        if (!acc[category]) {
          acc[category] = { category, total: 0 };
        }
        acc[category].total += spent;
        return acc;
      }, {})
  );

  const prevDataRef = useRef([]);

  const isDifferent =
    prevDataRef.current.length !== chartData.length ||
    JSON.stringify(prevDataRef.current) !== JSON.stringify(chartData);

  if (isDifferent) {
    prevDataRef.current = chartData;
    setCategoryChartData(chartData);
  }


  const productCounts = Object.values(
    filteredData
      .filter(row => {
        const cat = row.category_name?.trim();
        return cat && cat !== 'Unknown';
      })
      .reduce((acc, row) => {
        const category = row.category_name;
        if (!acc[category]) {
          acc[category] = { category, count: 0 };
        }
        acc[category].count += 1;
        return acc;
      }, {})
  );

  const prevCountRef = useRef([]);

  const isCountDifferent =
    prevCountRef.current.length !== productCounts.length ||
    JSON.stringify(prevCountRef.current) !== JSON.stringify(productCounts);

  if (isCountDifferent) {
    prevCountRef.current = productCounts;
    setProductCountByCategory(productCounts);
  }

  return (
    <div className={`reporttables reporttables-analysis ${filteredData.length === 0 ? 'empty' : ''}`}>
      <div className="filters">
        <div className="divtabe1">
          <label className="labels">Product Category</label>
          <Select
            options={categories}
            value={selectedCategory}
            onChange={handleCategoryChange}
            classNamePrefix="custom-select"
          />
        </div>
        <div className="divtabe1">
          <label className="labels">Branch</label>
          <Select
            options={branches}
            value={selectedBranch}
            onChange={handleBranchChange}
            classNamePrefix="custom-select"
          />
        </div>
        <div className="divtabe1">
          <label className="labels">From Date</label>
          <DatePicker
            selected={fromDate}
            onChange={(date) => {
              setFromDate(date);
              setToDate(null);
              const formatted = date ? date.toLocaleDateString('en-CA') : '';
              setFilters(prev => ({
                ...prev,
                date: {
                  ...prev.date,
                  start: formatted,
                }
              }));
            }}
            placeholderText=""
            dateFormat="dd/MM/yyyy"
            className="form-control"
          />
        </div>

        <div className="divtabe1">
          <label className="labels">To Date</label>
          <DatePicker
            selected={toDate}
            onChange={(date) => {
              setToDate(date);
              const formatted = date ? date.toLocaleDateString('en-CA') : '';
              setFilters(prev => ({
                ...prev,
                date: {
                  ...prev.date,
                  end: formatted,
                }
              }));
            }}
            placeholderText=""
            dateFormat="dd/MM/yyyy"
            className="form-control"
            minDate={fromDate}
            disabled={!fromDate}
          />
        </div>
        {/* <div className="divtabe1">
          <label className="labels">Select By Date Range</label>
          <DateRangePicker
            id="date"
            format="dd/MM/yyyy"
            value={range}
            onChange={(newRange) => {
              setRange(newRange);

              if (Array.isArray(newRange) && newRange[0] && newRange[1]) {
                const startFormatted = newRange[0].toLocaleDateString('en-CA');
                const endFormatted = newRange[1].toLocaleDateString('en-CA');

                setFilters(prev => ({
                  ...prev,
                  date: { start: startFormatted, end: endFormatted }
                }));
              } else {
                setFilters(prev => ({
                  ...prev,
                  date: ''
                }));
              }
            }}
            placeholder=" "
            style={{ width: '100%' }}
          />

        </div> */}
        <div className="divtabe1">
          <label className="labels">Export Table To</label>
          <div className="reportexport">
            <img src={pdf} alt="files" onClick={handleExportPDF} />
            <img src={csv} alt="files" onClick={handleExportCSV} />
          </div>
        </div>
      </div>
      {hasLoaded && (
        <>
          <DataTable
            columns={columns}
            data={filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)}
            pagination
            paginationServer
            paginationTotalRows={filteredData.length}
            onChangePage={page => setCurrentPage(page)}
            onChangeRowsPerPage={(newPerPage) => {
              setRowsPerPage(newPerPage);
              setCurrentPage(1);
            }}
            paginationRowsPerPageOptions={[20, 50, 100]}
            striped
            highlightOnHover
            responsive
          />
          <div className="reportsizelists">
            Showing {filteredData.length === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1}
            &nbsp;to&nbsp;
            {Math.min(currentPage * rowsPerPage, filteredData.length)} of {filteredData.length} entries
          </div>
        </>
      )}
    </div>

  );
}

export default Reportdatatable;